export const testimonials = {
  title: "What families say",
  subtitle: "Testimonials from our educational community",
  items: [
    {
      quote: "Gándara combines Montessori principles with flexibility, respect and joy. Our children feel happy, safe and curious every day, and we face the future with complete peace of mind.",
      author: "Alba & Marc",
      role: "Gándara family"
    },
    {
      quote: "We were looking for a Montessori, international school where our daughters would be truly happy. At Gándara we found all that and so much more.",
      author: "Patri & Pablo",
      role: "Gándara family"
    },
    {
      quote: "Gándara is a safe place where children grow up respected and supported. The teaching team is sensitive and truly understands each child.",
      author: "Marie",
      role: "Gándara family"
    }
  ]
};
